<template>
  <GridLayout class="webview" rows="60, *">
    <FlexboxLayout class="header" row="0" justifyContent="space-between" alignItems="center">
      <AgCaption dark noMargin :text="caption" />
      <AgIcon v-if="isDev" type="externalLink" @tap="open" @click="open" />
      <AgButton icon="times" iconSize="20" @tap="close" @click="close" />
    </FlexboxLayout>
    <WebView class="content" ref="content" row="1" :src="src" @loadStarted="$emit('loadStarted', $event)" @loadFinished="loadFinished" />
  </GridLayout>
</template>

<script>

import env from '@/helpers/env'
import url from '@/helpers/url'
import dialog from '@/helpers/dialog'

export default {
  props: {
    caption: String,
    title: String,
    src: String,
    closeTitle: String,
    closeMessage: String
  },
  computed: {
    isDev () {
      return env.mode === 'development'
    }
  },
  mounted() {
    // Add a message event listener to the window
    window.addEventListener('message', this.handleMessage);
  },
  
  beforeDestroy() {
    // Clean up the event listener when component is destroyed
    window.removeEventListener('message', this.handleMessage);
  },

  methods: {
    loadFinished (event) {
      if (env.isAndroid && env.isNative) {
        const settings = this.$refs.content.nativeView.android.getSettings()

        settings.setDomStorageEnabled(true)
        settings.setBuiltInZoomControls(false)
        settings.setDisplayZoomControls(false)
        settings.setSupportZoom(false)
      }

      this.$emit('loadFinished', event)
    },
    open () {
      url.open(this.src)
    },
    close () {
      if (this.closeTitle && this.closeMessage) {
        dialog.confirm({
          title: this.closeTitle,
          message: this.closeMessage,
          okButtonText: "OK",
          cancelButtonText: "Abbrechen"
        }).then(result => {
          if (result) {
            this.$emit('close')
          }
        })
      } else {
        this.$emit('close')
      }
    },
    handleMessage(event) {
      // Check the message data
      if (event.data && event.data.action === 'close_tariff_change') {
        // Call the close method when receiving the close message
        this.close();
      }
    },
  }
}

</script>

<style lang="scss" scoped>

.webview {
  position: fixed;
  width: 100%;
  height: 100%;

  .header {
    background-color: #9f9f9f;
    padding: env(safe-area-inset-top) env(safe-area-inset-right) 0 calc(env(safe-area-inset-left) + 20px);
  }

  .content {
    height: 100%;
  }
}

</style>